var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"page-content page-body text-left d-flex",attrs:{"fluid":""}},[_c('v-container',{staticClass:"page-container py-6",attrs:{"fluid":""}},[_vm._v(" 404 - Stránka nenalezena ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }